import { render, staticRenderFns } from "./workflow-trigger-intake-manager.vue?vue&type=template&id=b07d8c88"
import script from "./workflow-trigger-intake-manager.vue?vue&type=script&lang=js"
export * from "./workflow-trigger-intake-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports